export default __webpack_public_path__ + "media/images/icons_fc/chart3-16d771a62d5e9e79f8e48c153307480f.png";